import React from "react";
import { university } from "../../components";

const RecommenderCompare = () => {
  return <university.Compare />;
};

export default RecommenderCompare;
